module.exports = __webpack_public_path__ + "img/hqyj.1877604f.png";